<template>
	<section :class="['card card-accounts', { active: displayFormAccounts }]">
		<h2 @click="showForm()">
			rachunki
			<img
				src="images/icons/chevron-down-green.svg"
				:class="{ 'upside-down': displayFormAccounts }"
			/>
		</h2>

		<div class="float-right text-right user-env">
			<p class="lead">{{ userData.firstName }} {{ userData.lastName }}</p>
			<p>Status: Klient {{ userData.clientType }}</p>
			<p>
				{{ userData.email }}
				<template v-if="userData.mobilePhone && userData.email"
					>&nbsp;|&nbsp;</template
				>
				{{ userData.mobilePhone }}
			</p>
		</div>
		<div class="clearfix"></div>
		<transition tag="div" name="card-collapse">
			<keep-alive>
				<accounts-form />
			</keep-alive>
		</transition>
		<div
			v-if="
				getHost !== domains.mbankHost &&
				!(getCurrentUser && getCurrentUser.sso && getCurrentUser.mt)
			"
			class="footer-links ml-1"
		>
			<!-- <router-link
				to="/MyFx"
				class="btn btn-secondary"
				style="font-size: 15px"
				>moje dane</router-link
			> -->
			<a
				v-if="!userData.isCompany"
				href="#"
				rel="noopener noreferrer"
				class="btn btn-secondary text-green"
				style="font-size: 15px"
				@click.prevent="checkIfCanEdit('/MyFx')"
				>moje dane</a
			>
			<router-link
				v-if="!userData.isCompany"
				to="/Pit"
				class="btn btn-secondary"
				style="font-size: 15px"
				>PIT</router-link
			>
			<router-link
				to="/Mifid"
				class="btn btn-secondary"
				style="font-size: 15px"
				>ankieta MIFID</router-link
			>
		</div>
		<div v-else class="footer-links ml-1">
			<!-- :href="getMyDataUrl" -->
			<a
				href="#"
				rel="noopener noreferrer"
				class="btn btn-secondary text-green"
				style="font-size: 15px"
				@click.prevent="logoutAndRedirect(getMyDataUrl)"
				>moje dane</a
			>
			<router-link
				v-if="!userData.isCompany"
				to="/Pit"
				class="btn btn-secondary"
				style="font-size: 15px"
				>PIT</router-link
			>
			<router-link
				to="/Mifid"
				class="btn btn-secondary"
				style="font-size: 15px"
				>ankieta MIFID</router-link
			>
		</div>
	</section>
</template>

<script>
import AccountsForm from '@/views/dashboard/partial/_AccountsForm';
import { mapGetters } from 'vuex';

export default {
	components: {
		AccountsForm,
	},
	data() {
		return {
			// zmiana wyświetlania logowania w zalezności od tego na jakiej domenie jest user - wartości powinny być takie jak zwraca API
			/* eslint-disable */
			domains: {
				mbankHost: MBANK_HOST,
				mforexHost: MFOREX_HOST,
			},
		};
	},
	methods: {
		showForm() {
			this.$store.commit('setDisplayFormFastPayment', false);
			this.$store.commit('setDisplayFormPayout', false);
			this.$store.commit(
				'setDisplayFormAccounts',
				!this.displayFormAccounts,
			);
		},
		logoutAndRedirect(url) {
			this.$store.dispatch('logOut', {
				dontRedirect: true,
				redirectUrl: url,
			});
		},
		checkIfCanEdit(link) {
			if (this.$store.getters.getCanEditClientData) {
				this.$router.push(link);
			} else {
				this.$store.commit('setShowCanEditClientDataModal', true);
			}
		},
	},
	computed: {
		...mapGetters([
			'getHost',
			'getRedirectUrlAfterLogon',
			'getMyDataUrl',
			'getPitUrl',
			'getDisableOpenNewClientAccount',
			'getMifidUrl',
			'getOpenNewAccountUrl',
			'getCurrentUser',
			'getCanEditClientData',
		]),
		userData() {
			return this.$store.getters.getUser
				? this.$store.getters.getUser
				: false;
		},
		displayFormAccounts() {
			return this.$store.getters.getDisplayFormAccounts;
		},
	},
	mounted() {
		if (this.getHost !== this.domains.mbankHost) this.showForm();
	},
};
</script>
